import { commissionsSchema, calculationMethodsSchema } from 'features/common/schemas';
import { denormalize } from 'normalizr';
import createCachedSelector from 're-reselect';
import { emptyArray } from 'constants/emptyConst';

const COMMISSIONS_DEFAULT_DATA = {
  loading: true,
  loaded: false,
  saving: { commissions: false, subsidies: false },
  computed: { index: -1, isCommissionComputed: false, isSubsidyComputed: false }
};

const CALCULATION_METHODS_DEFAULT_DATA = { loading: true, loaded: false };

export const getCalcMethodsFlags = (currentOfferCalcMethodsState, _, id) =>
  currentOfferCalcMethodsState[id] || CALCULATION_METHODS_DEFAULT_DATA;
export const getCalculationMethodsState = (_, entitiesState, id) =>
  Object.assign([], denormalize(id, calculationMethodsSchema, entitiesState));

export const getCalculationMethodsFlags = createCachedSelector(
  getCalcMethodsFlags,
  flags => flags
)((_currentOfferCalcMethodsState, _entitiesState, key) => key);

export const getCalculationMethods = createCachedSelector(
  getCalculationMethodsFlags,
  getCalculationMethodsState,
  (flags, calculationMethods) => {
    if (!flags.loaded) {
      return emptyArray;
    }
    return calculationMethods;
  }
)((_currentOfferCalcMethodsState, _entitiesState, key) => key);

const getFlags = (currentOfferCommissionsState, _, id) => currentOfferCommissionsState[id] || COMMISSIONS_DEFAULT_DATA;

const getCommissionsState = (_, entitiesState, id) => denormalize(id, commissionsSchema, entitiesState);

export const getCommissionsFlags = createCachedSelector(
  getFlags,
  flags => flags
)((_currentOfferCommissionsState, _entitiesState, key) => key);

export const getCommissions = createCachedSelector(getCommissionsFlags, getCommissionsState, (flags, commissions) => {
  if (!flags.loaded) {
    return emptyArray;
  }
  const data = commissions?.commissionsDetails;
  return data ? data.filter(com => com.isCommission) : emptyArray;
})((_currentOfferCommissionsState, _entitiesState, key) => key);

export const getOfferCurrency = offerHeader => {
  const { currencyId, currencyCode } = offerHeader;
  return { currencyId, currencyCode };
};

export const getSubsidies = createCachedSelector(getCommissionsFlags, getCommissionsState, (flags, commissions) => {
  if (!flags.loaded) {
    return emptyArray;
  }
  const data = commissions?.commissionsDetails;
  return data ? data.filter(com => com.isSubsidy) : emptyArray;
})((_currentOfferCommissionsState, _entitiesState, key) => key);
